import BlockManager from './blockManager';

export default BlockManager;